const host = {
  development: 'https://www.codoon.com/activity/v1/gp-super-activity',
  production: 'https://www.codoon.com/activity/v1/gp-super-activity'
}
const baseUrl = `${host[process.env.NODE_ENV]}`
const shareOption = {
  title: '待办约定|为爱夜奔，超霸电光为精彩赋能',
  img: 'https://webapp.codoon.com/superba_codoon_run/upload/share.jpg',
  link: 'https://www.codoon.com/activity/v2/superba_codoon_run/index.html#/outhome',
  codoonLink: 'https://www.codoon.com/activity/v2/superba_codoon_run/index.html',
  des: 'GP超霸最燃夜跑派对来袭，8月24日以持续的电量，让精彩一直在线！'
}

let now = '2019-08-01'
now = now.replace(/-/g, '/')

// 8月1号后面使用其他分享文案
if (new Date() > new Date(now)) {
  shareOption.title = '充满电，跟我跑'
  shareOption.des = '精彩不断电，心只为此燃！GP超霸邀您为爱而跑，与你一起点燃每一个精彩瞬间！'
}

export {
  host,
  baseUrl,
  shareOption
}
